import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Rahul Rathnavel loader</title>
    <polygon
      fill="none"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="50 5 11 27 11 72 50 95 89 73 89 28"
    />
    <text
      x="50"
      y="63"
      textAnchor="middle"
      fill="currentColor"
      fontFamily="monospace"
      fontSize="30"
      fontWeight="700"
      id="initials">
      RR
    </text>
  </svg>
);

export default IconLoader;
